import styles from "./style.module.scss";
import { useVisibility } from "../../../../hooks/useVisibility";
import { Drawer, Tooltip } from "antd";
import ShareIcon from "assets/icons/ShareIcon";
import { DatasetShare } from "./DatasetShare";

export const DatasetShareButton = ({
  className,
  datasetId,
}: {
  datasetId: string;
  className?: string;
}) => {
  const drawerVisibility = useVisibility();
  return (
    <>
      <div
        className={className}
        data-testid="dataset-share-btn"
        onClick={drawerVisibility.open}
      >
        <Tooltip title="Share">
          <ShareIcon />
        </Tooltip>
      </div>
      <Drawer
        classNames={{ body: styles.drawer }}
        closable={false}
        open={drawerVisibility.isOpen}
        onClose={drawerVisibility.close}
      >
        {drawerVisibility.isOpen && (
          <DatasetShare
            datasetId={datasetId}
            onClose={drawerVisibility.close}
          />
        )}
      </Drawer>
    </>
  );
};
